import { render, staticRenderFns } from "./ToiletBoxEditor.vue?vue&type=template&id=60c420c5&scoped=true&lang=pug"
import script from "./ToiletBoxEditor.vue?vue&type=script&lang=ts"
export * from "./ToiletBoxEditor.vue?vue&type=script&lang=ts"
import style0 from "./ToiletBoxEditor.vue?vue&type=style&index=0&id=60c420c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c420c5",
  null
  
)

export default component.exports